import React, { Suspense, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../../views/Login/Login";
import LoginV2 from "../../views/Login/Loginv2";
import HealthTracker from "../../views/Login/HealthTracker/HealthTracker";

const RouterGuest = ({ setAuth }) => {


    return (
        <Routes>
            <Route exact path="/" element={<Suspense fallback={<>Skeleton</>}>
                <LoginV2 ></LoginV2>
            </Suspense>} />

            <Route exact path="/bienestar" element={<Suspense fallback={<>Skeleton</>}>
                <HealthTracker></HealthTracker>
            </Suspense>} />
            <Route exact path="/*" element={<Suspense fallback={<>Skeleton</>}>
            <LoginV2 ></LoginV2>
            </Suspense>} />
        </Routes>
    )
}
export default RouterGuest